import { History } from "lucide-react";
import { FoundingAccessHistoryEntry } from "./types";
import { formatFoundingAccessHistoryDate } from "./helpers";

export function FoundingAccessHistoryList({ history }: { history: FoundingAccessHistoryEntry[] }) {
  if (!history.length) {
    return (
      <div
        className="rounded-md border bg-muted/30 px-3 py-3 text-xs text-muted-foreground"
        data-testid="founding-access-history-empty"
      >
        <div className="flex items-center gap-1.5 font-medium text-foreground mb-1">
          <History className="h-3.5 w-3.5" /> Recent changes
        </div>
        No changes recorded yet. The next save will appear here with the admin
        who made it and the previous value.
      </div>
    );
  }
  return (
    <div className="space-y-2" data-testid="founding-access-history">
      <div className="flex items-center gap-1.5 text-xs font-medium">
        <History className="h-3.5 w-3.5" /> Recent changes
      </div>
      <div className="rounded-md border divide-y">
        {history.map((entry) => {
          const sameValue =
            (entry.previousLaunchDate ?? null) === (entry.newLaunchDate ?? null);
          return (
            <div
              key={entry.id}
              className="px-3 py-2 text-xs space-y-0.5"
              data-testid={`founding-access-history-entry-${entry.id}`}
            >
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <span className="font-medium" data-testid={`founding-access-history-actor-${entry.id}`}>
                  {entry.changedBy || "Unknown admin"}
                </span>
                <span className="text-muted-foreground" data-testid={`founding-access-history-when-${entry.id}`}>
                  {new Date(entry.changedAt).toLocaleString()}
                </span>
              </div>
              {sameValue ? (
                <div className="text-muted-foreground">
                  Re-saved without changing the value{" "}
                  <span className="text-foreground">
                    ({formatFoundingAccessHistoryDate(entry.newLaunchDate)})
                  </span>
                </div>
              ) : (
                <div className="text-muted-foreground">
                  <span data-testid={`founding-access-history-from-${entry.id}`}>
                    {formatFoundingAccessHistoryDate(entry.previousLaunchDate)}
                  </span>
                  {" → "}
                  <span
                    className="text-foreground font-medium"
                    data-testid={`founding-access-history-to-${entry.id}`}
                  >
                    {formatFoundingAccessHistoryDate(entry.newLaunchDate)}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
